import { Send } from "lucide-react";

/** The one sentence the approval screen uses for a purchase that already went out (TASK-208). */
export const PRESEND_HEADLINE = "Schon zur Meldung an Meta/Google übergeben – dort nicht rücknehmbar";

export function sentAtLabel(iso: string): string {
  return new Date(iso).toLocaleString("de-DE", {
    dateStyle: "short",
    timeStyle: "short",
    timeZone: "Europe/Berlin",
  });
}

/** Compact marker for a list row. Renders nothing for a purchase that was not sent in advance. */
export function PresendBadge({ at }: { at: string | null }) {
  if (!at) return null;
  return (
    <span
      title={`${PRESEND_HEADLINE} (${sentAtLabel(at)})`}
      className="inline-flex items-center gap-1 rounded-full bg-warning-bg px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-warning"
    >
      <Send size={9} aria-hidden="true" />
      Schon übergeben
    </span>
  );
}

/** Full notice for the detail view and the reject dialog: reject only keeps it out of OUR evaluation. */
export function PresendNotice({ at }: { at: string | null }) {
  if (!at) return null;
  return (
    <div
      role="note"
      className="rounded-md border border-warning bg-warning-bg px-4 py-3 text-sm text-warning"
    >
      <p className="font-semibold">{PRESEND_HEADLINE}</p>
      <p className="mt-1 text-xs">
        Übergeben am {sentAtLabel(at)}. Genehmigen nimmt den Kauf in die Auswertung auf, ohne ihn
        erneut zu melden. Ablehnen hält ihn nur aus unserer Auswertung heraus.
      </p>
    </div>
  );
}

/** Warning for the bulk reject: shown when at least one selected case was already handed over. */
export function PresendBulkNotice({ count, total }: { count: number; total: number }) {
  if (count <= 0) return null;
  return (
    <div
      role="note"
      className="rounded-md border border-warning bg-warning-bg px-4 py-3 text-sm text-warning"
    >
      <p className="font-semibold">{PRESEND_HEADLINE}</p>
      <p className="mt-1 text-xs">
        {count} von {total} ausgewählten Fällen {count === 1 ? "wurde" : "wurden"} schon übergeben.
        Ablehnen hält sie nur aus unserer Auswertung heraus.
      </p>
    </div>
  );
}

/** Reason shown for an approval row that carries no deciding rule (rule check failed technically). */
export const RULE_CHECK_FAILED = "Regelprüfung fehlgeschlagen";

export function RuleCheckFailedBadge({ failed }: { failed: boolean }) {
  if (!failed) return null;
  return (
    <span
      title="Die Regelprüfung ist technisch fehlgeschlagen, der Fall wartet auf eine Entscheidung"
      className="inline-flex items-center rounded-full bg-danger-bg px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wider text-danger"
    >
      {RULE_CHECK_FAILED}
    </span>
  );
}
